import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'messageTimezone'
})
export class MessageTimeZonePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return moment.utc(value ).local().format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/message-time-zone.pipe.ts